import Skeleton from '@components/Skeleton';
import { Fragment } from 'react';

function PrepaidCardRowSkeletons() {
    return (
        <Fragment>
            <Skeleton width='100%' height={74} shape='block'/>
            <Skeleton width='100%' height={74} shape='block'/>
        </Fragment>
    );
}

export default PrepaidCardRowSkeletons;
